import { Navigate, redirect, useNavigate, useParams } from 'react-router-dom';
import { useChannel } from '@/hooks/api/useChannel';
import { useChannelPost } from '@/hooks/api/useChannelPost';
import { Body } from '@/components/channel_post/Body';
import { Header as ChannelPostHeader } from '@/components/channel_post/Header';
import { RelCreators } from '@/components/channel_post/RelCreators';
import { Information } from '@/components/channel_post/Information';
import queryClient from '@/lib/queryClient';
import { useChannelPosts } from '@/hooks/api/useChannelPosts';
import { Description } from '@/components/channel_post/Description';
import { SpriteSvg } from '@/components/common/SpriteSvg';

export const ModalChannelPost = () => {
  const navigate = useNavigate();
  const params = useParams<{ cid: string; id: string }>();
  const { data: channel, isError: isChannelError } = useChannel(params.cid!);
  const { data: channel_post, isError: isChannelPostError } = useChannelPost(params.cid!, Number(params.id!));

  if (isChannelError || isChannelPostError) {
    const { invalidate } = useChannelPosts(params.cid!);
    invalidate();
    return <Navigate replace to={`/channels/${params.cid!}`} />;
  }

  if (channel == null || channel_post == null) return <></>;

  return (
    <div className="post-modal-wrapper active">
      <div className="backdrop" onClick={() => navigate(-1)}></div>
      <div className="post-modal">
        <button className="post-modal-close" onClick={() => navigate(-1)}>
          <SpriteSvg name={'icon-modal-close'} className={'i'} />
        </button>
        <section className="post">
          <div className="post">
            <ChannelPostHeader channel_post={channel_post} from_modal={true} />
            <Information channel_post={channel_post} from_modal={true} />
            <Body playable={true} channel_post={channel_post} />
            <RelCreators channel_post={channel_post} />
            <Description channel_post={channel_post} />
          </div>
        </section>
      </div>
    </div>
  );
};
